import React from 'react';
import Container from '../common/Container';
import Card from '../common/Card';
import Button from '../common/Button';
import { useNavigate } from 'react-router-dom';

const TermsOfService: React.FC = () => {
  const navigate = useNavigate();

  const handleBackToGame = () => {
    navigate('/');
  };

  return (
    <div className="min-h-screen bg-dark-950">
      <Container>
        <div className="max-w-4xl mx-auto py-8">
          <Card>
            <div className="p-8">
              <h1 className="text-3xl font-bold text-primary-400 mb-6">Terms of Service</h1>
              
              <div className="prose prose-gray max-w-none">
                <p className="text-dark-300 mb-6">
                  Last updated: {new Date().toLocaleDateString()}
                </p>

                <section className="mb-8">
                  <h2 className="text-2xl font-semibold text-primary-300 mb-4">1. Acceptance of Terms</h2>
                  <p className="text-dark-200 mb-4">
                    By accessing and using the AI Guessing Game ("the Game"), you accept and agree to be bound by the terms and provision of this agreement.
                  </p>
                </section>

                <section className="mb-8">
                  <h2 className="text-2xl font-semibold text-primary-300 mb-4">2. Description of Service</h2>
                  <p className="text-dark-200 mb-4">
                    The AI Guessing Game is an interactive web-based game where users attempt to distinguish between AI-generated and human-written text content. The game is provided for entertainment and educational purposes.
                  </p>
                </section>

                <section className="mb-8">
                  <h2 className="text-2xl font-semibold text-primary-300 mb-4">3. User Conduct</h2>
                  <p className="text-dark-200 mb-4">
                    You agree to use the Game in a manner consistent with any and all applicable laws and regulations. You agree not to:
                  </p>
                  <ul className="list-disc list-inside text-dark-200 mb-4 ml-4">
                    <li>Use the Game for any unlawful purpose or to solicit others to perform unlawful acts</li>
                    <li>Violate any international, federal, provincial, or state regulations, rules, or laws</li>
                    <li>Harass, abuse, insult, harm, defame, slander, disparage, intimidate, or discriminate</li>
                    <li>Submit false or misleading information</li>
                    <li>Attempt to reverse engineer or hack the Game</li>
                  </ul>
                </section>

                <section className="mb-8">
                  <h2 className="text-2xl font-semibold text-primary-300 mb-4">4. Privacy and Data Collection</h2>
                  <p className="text-dark-200 mb-4">
                    We collect minimal data necessary for game functionality, including game scores and usage statistics. We do not collect personal information unless explicitly provided. All data is handled in accordance with applicable privacy laws.
                  </p>
                </section>

                <section className="mb-8">
                  <h2 className="text-2xl font-semibold text-primary-300 mb-4">5. Intellectual Property</h2>
                  <p className="text-dark-200 mb-4">
                    The Game and its original content, features, and functionality are owned by the Game developers and are protected by international copyright, trademark, patent, trade secret, and other intellectual property laws.
                  </p>
                </section>

                <section className="mb-8">
                  <h2 className="text-2xl font-semibold text-primary-300 mb-4">6. Disclaimer of Warranties</h2>
                  <p className="text-dark-200 mb-4">
                    The Game is provided on an "AS IS" and "AS AVAILABLE" basis. We make no representations or warranties of any kind, express or implied, as to the operation of the Game or the information, content, materials, or products included therein.
                  </p>
                </section>

                <section className="mb-8">
                  <h2 className="text-2xl font-semibold text-primary-300 mb-4">7. Limitation of Liability</h2>
                  <p className="text-dark-200 mb-4">
                    In no event shall the Game developers be liable for any damages of any kind arising from the use of the Game, including but not limited to direct, indirect, incidental, punitive, and consequential damages.
                  </p>
                </section>

                <section className="mb-8">
                  <h2 className="text-2xl font-semibold text-primary-300 mb-4">8. Changes to Terms</h2>
                  <p className="text-dark-200 mb-4">
                    We reserve the right to modify these terms at any time. Changes will be effective immediately upon posting. Your continued use of the Game after any changes constitutes acceptance of the new terms.
                  </p>
                </section>

                <section className="mb-8">
                  <h2 className="text-2xl font-semibold text-primary-300 mb-4">9. Contact Information</h2>
                  <p className="text-dark-200 mb-4">
                    If you have any questions about these Terms of Service, please contact us through the game interface or repository.
                  </p>
                </section>
              </div>

              <div className="mt-8 pt-6 border-t border-dark-700">
              <Button
                onClick={handleBackToGame}
                variant="primary"
                className="w-full sm:w-auto"
              >
                Back to Game
              </Button>
            </div>
          </div>
          </Card>
        </div>
      </Container>
    </div>
  );
};

export default TermsOfService;